(function () {
    'use strict';

    angular.module("imApp").factory("productMultiUnitService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1080,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1081,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
